export const SitecoreIds = {
  Foundation: {
    Enterprise: {
      BaseTemplates: {
        _Article: {
          TemplateId: 'FE92A6FD-F7EF-4127-970D-A75988A9E946',
        },
        _BasePhoto: {
          TemplateId: 'DD38514D-89E9-47F5-9A34-F5DAA3E8C852',
        },
        _BaseGalleryVideo: {
          TemplateId: '50ABE846-9E6F-45AB-A903-96404081223D',
        },
        _BaseSerializeChildren: {
          TemplateId: 'FF89A198-11C2-4D74-ABB0-F137858FA97B',
        },
        Pages: {
          _BasePage: 'ABF549D3-3225-4821-9336-3D395CD86D32',
        },
      },
      FieldSets: {
        Search: {
          _IndexableItem: 'BCD96EB5-B307-4230-918E-A5F9FC5DBCEF',
        },
      },
      Extensions: {
        _EnterpriseWebPage: 'E24802C8-F876-472F-9719-CC7090EAE42D',
      },
    },
    AndersenWindows: {
      BaseTemplates: {
        Pages: {
          _BaseArticlePage: '2CC6E443-B9E1-4FBE-AD1B-A68E3A197997',
          _BaseAWPage: '5DCCAF20-BE0A-4242-9CFF-DEB9C7380CB3',
          _BaseProjectShowcasePage: 'CB0FDACB-4C5B-4A84-A852-395A29990241',
        },
      },
    },
    RenewalbyAndersen: {
      BaseTemplates: {
        Pages: {
          _BaseArticlePage: '1A88B6D9-497A-4498-B463-27E3B85D209B',
        },
      },
      Fieldsets: {
        Search: {
          _SearchFieldsets: '88B2F728-B5A0-44C4-BE3F-677F33204F5D',
        },
        Affiliates: {
          _BaseJob: '55D56C2E-0478-4511-8CF4-2E10DACB41B2',
        },
      },
    },
  },
  Feature: {
    AndersenWindows: {
      Data: {
        Photos: {
          Photo: {
            TemplateId: '2AC3A258-2F0A-4081-BB8E-F00E281D4311',
          },
        },
        Videos: {
          GalleryVideo: {
            TemplateId: 'A3A3CA99-D535-4E53-AAB9-C05FDEB02F3D',
          },
        },
      },
    },
    RenewalByAndersen: {
      Data: {
        Photos: {
          Photo: {
            TemplateId: '9921E67C-1B67-400D-BD2C-91D70562B840',
          },
        },
        Videos: {
          GalleryVideo: {
            TemplateId: '5DABD9C5-9C73-46B0-A2F1-41A0491A322E',
          },
        },
        Affiliates: {
          Datasources: {
            Event: {
              TemplateId: 'D65D7977-8ECB-4CFD-B30B-F08C8C2A5C73',
            },
            Award: {
              TemplateId: 'E49BB4DD-C984-4CD9-B013-140DFF3E06F8',
            },
            Showroom: {
              TemplateId: 'B9F8C372-1222-4933-979F-9094D10AAB7B',
            },
            Job: {
              TemplateId: '215D5197-C15F-46FF-B762-DA23E17E83DD',
            },
            JobsFolder: {
              TemplateId: '8AA2FE02-2C12-471B-86C1-9D73A6427ADC',
            },
            CampaignLandingPage: {
              TemplateId: '9A2B5B04-B157-4815-BF34-18044718135E',
            },
          },
        },
      },
    },
    Data: {
      Elements: {
        Image: {
          TemplateId: '02e0e9ef-6908-453a-886d-641f4908e1a6',
        },
        Videos: {
          FacebookVideo: {
            TemplateId: 'e2dd131a-bd4e-43ab-8a8c-de118fe9aff2',
          },
          VimeoVideo: {
            TemplateId: '396f8987-9ec8-4916-9b38-7d9f8499e3f6',
          },
          YouTubeVideo: {
            TemplateId: '10ffc85c-56a6-4a99-953c-56bb3405c1e6',
          },
        },
        Product: {
          ComparisonSection: {
            templateId: 'af246fa9-e4e1-40df-b1f2-84746e50e00f',
          },
          ComparisonSubsection: {
            templateId: '2daecb3c-e930-4e12-b5e9-9239bcad10cb',
          },
        },
      },
      Documents: {
        TechnicalDocument: {
          TemplateId: '185E5295-D62B-4B47-93B2-72E59A3F5360',
        },
        PDF: {
          TemplateId: '7088D1CA-0193-405F-83A5-B31E98BB2300',
        },
      },
      Products: {
        AW: {
          Product: {
            TemplateId: '15B220E7-B36D-4C65-8F33-AA8B635449D4',
          },
          ProductConfiguration: {
            TemplateId: 'AFE4A298-0FB4-4D78-A699-E96B98CE94DE',
          },
        },
      },
      Affiliates: {
        Affiliate: {
          TemplateId: '561698E7-FA54-4801-B8C4-F1866F10B57F',
        },
        AffiliateShowroomsFolder: {
          TemplateId: '48753FDE-B52C-4A23-9B7B-4C593EFA4826',
        },
        Showroom: {
          TemplateId: 'B9F8C372-1222-4933-979F-9094D10AAB7B',
        },
        AffiliateOffersFolder: {
          TemplateId: '7A4A17E5-19DD-4DC0-A9D3-D5E662B20317',
        },
        Offers: {
          TemplateId: '3B07FB29-6ECA-4D8E-809D-1027F71CE17E',
        },
      },
      FeatureToggles: {
        FeatureToggle: {
          TemplateId: 'D0A7A158-A75F-46E3-BEAC-BEDEC75B26BD',
        },
      },
      Geography: {
        Province: {
          TemplateId: 'C509B971-F5A0-40A8-BE4A-112B56DFF74D',
        },
        State: {
          TemplateId: 'E43BCE6C-C44D-49EC-8347-E76DBAB1BDCD',
        },
      },
    },
    Components: {
      Header: {
        AW: {
          RAQMobileBanner: {
            TemplateId: 'f5213b1c-f643-498d-b043-19b185804026',
          },
        },
        RbA: {
          NavigationGroup: {
            TemplateId: '5f46fc87-1acc-460c-8ff2-ba018441a7da',
          },
          MegaMenu: {
            TemplateId: 'e26df5d9-4bd0-470f-8205-6cff21b841f9',
          },
          TileItem: { TemplateId: '2c65efe1-b7a1-4ced-9ada-6cd4cc79aa35' },
          LinkItem: { TemplateId: '60b6e011-b348-41a2-be90-0a7469063ae5' },
        },
      },
      StormDoorChooseTool: {
        Question: {
          TemplateId: '64B071AB-1058-4FF8-B128-4D62B539CCCD',
        },
        Recommendation: {
          TemplateId: '57330B4D-64AC-4DAD-9F5A-6776CF1BE815',
        },
        Answer: {
          TemplateId: '1831E880-F641-4CEF-9D28-96B614042637',
        },
      },
      DesignTool: {
        DataSource: {
          TemplateId: '9249C619-06E7-4449-A0A4-7907BEFAD1AB',
        },
        Option: {
          TemplateId: '8547B7A7-9887-4402-B764-973A09B8906C',
        },
        Product: {
          TemplateId: '957FEB2C-1DB0-4D9B-A443-4E9FCAE16F4E',
        },
      },
      ProductVisualizer: {
        MakeabilityRules: {
          TemplateId: 'DFD715F3-84B4-46A9-A92B-51E6C78EE6E2',
        },
        OptionAutosetRules: {
          TemplateId: '0008B564-AE4E-4260-B63D-01F9FDF30556',
        },
      },
    },
  },
  Content: {
    AndersenCorporation: {
      ItemId: '68B9BA98-AC50-4DF6-B8F0-D32C72BECF20',
      AndersenWindows: {
        Global: {
          ProductsFolder: {
            ItemId: '6BB32758-D223-484A-B7C8-0AE22613C318',
          },
        },
      },
      RenewalByAndersen: {
        Global: {
          Affiliates: {
            ItemId: '1F5AB56B-F49F-4148-94FF-25E6867D7434',
          },
          DataSources: {
            ItemId: '0C94BFB7-47D4-4ABE-978F-8A95DD44FA10',
            Geography: {
              ItemId: '333774CE-BD59-48F6-8F29-35C379E84D4E',
              States: {
                ItemId: '66F692EF-AB7B-4423-931F-35558DAF9150',
              },
            },
          },
        },
      },
      EnterpriseGlobal: {
        Settings: {
          FeatureToggles: {
            ItemId: '794A128B-3E88-4475-B5B5-474ADBDAED0D',
          },
        },
      },
    },
  },
  Project: {
    AndersenWindows: {
      Pages: {
        StandardPage: {
          ItemId: '6af8b67c-1137-4b57-a0e4-9eeeb1dfccfa',
        },
        ArticlePage: {
          ItemId: '9256edf3-d0fa-4588-adda-3036b9d04faa',
        },
        PrjectShowcasePage: {
          ItemId: 'a28667e9-0cd2-46a9-a228-0f6c8d85b817',
        },
      },
    },
    RenewalByAndersen: {
      Common: {
        JSSSettings: {
          TemplateId: '09d553fc-779c-4ab1-a2a4-6f3076345850',
        },
        JSSSiteGrouping: {
          TemplateId: '8040f561-7630-4962-b9e0-03762f1b18b1',
        },
      },
      Pages: {
        StandardPage: {
          ItemId: '79c7f0af-3f65-49ca-8211-80f33eff62ee',
        },
        ArticlePage: {
          ItemId: '9520f84e-bfb8-4fbd-80d5-58fd2a5c24c7',
        },
      },
    },
  },
  Settings: {
    Rules: {
      Definitions: {
        Elements: {
          EW_Affiliate: {
            AffiliateMatch: {
              ItemId: '{96DBD54A-2742-4E37-9FD2-6D0875A27D47}',
            },
            AffiliateField: {
              ItemId: '{6C9BADDC-602D-4EC7-B1DA-DC693FD0D4AB}',
            },
            AffiliateProgramOptIn: {
              ItemId: '{CBA76F1D-28CD-4B4D-B42D-EEB9660CB95C}',
            },
          },
          EW_Page: {
            PageIsMatch: {
              ItemId: '{BF7B4E26-FDA3-4368-B712-6971ED14209E}',
            },
          },
          EW_Geolocation: {
            State: {
              ItemId: '{1BEAC081-5425-45F7-BE1C-48243B5EB3D8}',
            },
          },
          EW_Rendering: {
            HideItemOrRendering: {
              ItemId: '{51AE17AC-9A47-488B-B37E-C7AA9AB2937D}',
            },
            ShowItemOrRendering: {
              ItemId: '{5EB42810-A5A1-4190-B765-8EE372740FDF}',
            },
          },
          EW_Request: {
            CookieIsPresent: {
              ItemId: '{6D042D01-1EEA-4881-9175-6729899B0FF1}',
            },
            CookieValue: {
              ItemId: '{89124B09-912E-40D0-A0BA-20F5F0096EE8}',
            },
            QueryString: {
              ItemId: '{5C811A21-1FB4-4810-B13F-A4695EDC5DA2}',
            },
          },
          RbA_Reviews: {
            UserAffiliate: {
              ItemId: '{560AA662-EF12-408B-B23A-A0917B8EA91F}',
            },
            PageAffiliate: {
              ItemId: '{83B7D6E7-2DC2-4ED9-811E-0C308B78CA62}',
            },
            SpecificAffiliate: {
              ItemId: '{FABE2176-8EF0-4354-8DBC-A99587A21BD3}',
            },
            MinimumCharacterCount: {
              ItemId: '{5CBB3327-512E-4BE1-9B1B-F56E3BC88824}',
            },
            Product: {
              ItemId: '{BAD3BFAD-7DB9-4E89-A981-D395B240C0B4}',
            },
            MinimumRating: {
              ItemId: '{58AE071C-2285-4933-B5E2-3AB08AC77FB0}',
            },
            TextReviewContains: {
              ItemId: '{55AF949F-27D8-4F49-A813-60A860599C75}',
            },
          },
        },
      },
    },
  },
  System: {
    Rules: {
      Personalization: {
        Conditions: {
          CookieIsPresent: {
            ItemId: '{F1B07EC4-B2A3-42E7-BAC3-6322D65249D9}',
          },
          CookieValue: {
            ItemId: '{D710C860-0B1C-468A-845F-2A1BD7601B1B}',
          },
          AffiliateField: {
            ItemId: '{20362397-97AB-4006-BC69-EE8F733C8F8A}',
          },
          QueryString: {
            ItemId: '{A8D1FC15-811C-4856-9414-899EB158039B}',
          },
          AffiliateIsMatch: {
            ItemId: '{A226F99C-9833-4FED-9267-96480352C3D6}',
          },
          PageIsMatch: {
            ItemId: '{B9CD1DDE-C42F-4C19-A3EB-CEB5C08C593D}',
          },
          AffiliateProgramOptIn: {
            ItemId: '{956814D4-5CD7-4198-BD9F-93CF22BB1E8F}',
          },
        },
        Actions: {
          HideComponentOrItem: {
            ItemId: '{59AA4786-E773-44FC-AB1B-CA5BF1FC43C4}',
          },
          SetDataSourceOrReplaceItem: {
            ItemId: '{6F40C754-4054-4861-8954-574F10423E43}',
          },
        },
      },
    },
  },
};
